module.exports = __webpack_public_path__ + "static/media/the-dutch_jager.1e85c4f0.jpg";